import * as React from 'react';

import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from '@/components/TailwindComponents/lib/utils';
const VerticalTabs = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Root>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Root
    ref={ref}
    className={cn('flex h-full w-full', className)}
    {...props}
  />
));
VerticalTabs.displayName = TabsPrimitive.Root.displayName;

const VerticalTabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'w-[240px] bg-gray-50 dark:bg-gray-800 flex-none flex flex-col border-r border-gray-200 dark:border-gray-700 p-2 pt-1',
      className,
    )}
    {...props}
  />
));
VerticalTabsList.displayName = TabsPrimitive.List.displayName;

interface VerticalTabsTriggerProps
  extends React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> {
  icon?: React.ReactNode;
}

const VerticalTabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  VerticalTabsTriggerProps
>(({ className, children, icon, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'w-full inline-flex items-center rounded-md gap-3 justify-start mt-1 px-6 py-3 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-red-500 transition-all hover:bg-red-200 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50',
      'data-[state=active]:bg-red-200 data-[state=active]:text-red-500',
      className,
    )}
    {...props}
  >
    {icon && <span className="flex-shrink-0 w-5 h-5">{icon}</span>}
    {children}
  </TabsPrimitive.Trigger>
));
VerticalTabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const VerticalTabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn('flex-auto p-6', className)}
    {...props}
  />
));
VerticalTabsContent.displayName = TabsPrimitive.Content.displayName;

const VerticalTabsContainer = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex h-full w-full bg-white dark:bg-gray-800', className)}
    {...props}
  />
));
VerticalTabsContainer.displayName = 'VerticalTabsContainer';

export {
  VerticalTabs,
  VerticalTabsContainer,
  VerticalTabsContent,
  VerticalTabsList,
  VerticalTabsTrigger,
};
